import React, { Component } from 'react'
import MUIDataTable from 'mui-datatables'
import gql from 'graphql-tag'
import { withApollo } from 'react-apollo'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import moment from 'moment'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import BulkUpload from './BulkUpload'
import { FormControl, InputLabel, TextField, Modal } from '@material-ui/core'
import Select from 'react-select'
import SendCommands from '../VehcileDashboard/SendCommands'
import axios from 'axios'
import Multiselect from 'multiselect-react-dropdown'
import { DateTimePicker } from 'material-ui-pickers'

const style = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  iconSmall: {
    fontSize: 20
  }
})

const GET_VEHICLE_LIST = gql`
  query getAllVehicleDetailsByStatus($loginId: Int, $status: Int) {
    getAllVehicleDetailsByStatus(partnerLoginId: $loginId, status: $status) {
      vehicleNumber
      deviceDetail {
        uniqueDeviceId
      }
    }
  }
`
const GET_UPLOAD_URL = gql`
  mutation($fileExtension: String!) {
    getPublicUploadURL(fileExtension: $fileExtension) {
      bucketName
      filename
      publicUploadURL
    }
  }
`

const GET_COMMAND_STATUS = gql`
  query getCommandStatus(
    $uniqueIds: [String!]!
    $command: String
    $from_ts: Int
    $to_ts: Int
  ) {
    getCommandStatus(
      uniqueIds: $uniqueIds
      command: $command
      from_ts: $from_ts
      to_ts: $to_ts
    ) {
      id
      uniqueid
      command_display
      status
      create_ts
      modified_ts
      response
    }
  }
`

class VehicleCommands extends Component {
  constructor(props) {
    super(props)
    this.classes = props
  }
  clientId = []

  columns = ['SLNO', 'COMMAND', 'RESPONSE', 'STATUS']

  options = {
    selectableRows: false,
    responsive: 'scroll',
    rowsPerPage: 10
  }

  state = {
    open: false,
    openBulkModal: false,
    open1: false,
    fromDate: null,
    toDate: null,
    toMaxDate: new Date(),
    vehicleNames: [],
    commandsList: [],
    selectedVehicles: [],
    selectedFormDate: new Date(),
    selectedToDate: new Date(),
    invalidToDate: false
  }

  getvehicleDetails = async () => {
    const { data } = await this.props.client.query({
      query: GET_VEHICLE_LIST,
      variables: {
        loginId: parseInt(localStorage.getItem('Login_id'), 10),
        status: 1
      }
    })

    const allVehicles = data.getAllVehicleDetailsByStatus.map(v => ({
      id: v.deviceDetail.uniqueDeviceId,
      name: v.vehicleNumber
    }))
    this.setState({ vehicleNames: allVehicles })
    this.setState({
      vehicleNames: [
        { id: 'SELECT000000ALL', name: 'Select All' },
        ...this.state.vehicleNames
      ]
    })
  }

  handleClickOpen = () => {
    this.setState({ open: true })
  }

  handleBulkOpen = () => {
    this.setState({ openBulkModal: true })
  }

  handleClose = () => {
    this.setState({ open: false })
    this.setState({ openBulkModal: false })
  }

  handleToDate = date => {
    this.setState({ selectedToDate: date })
    var endTs = moment(date).unix()
    this.setState({ toDate: endTs })
  }

  handleFromDate = date => {
    this.setState({ selectedFormDate: date })
    var finalStart = moment(date).unix()
    this.setState({ fromDate: finalStart })

    var dateNow = new Date(date) // Now
    dateNow.setDate(dateNow.getDate() + 30)
    this.setState({ toMaxDate: dateNow })
  }

  onUpload = async ({
    target: {
      validity,
      files: [file]
    }
  }) => {
    this.setState({ isUploading: true })
    if (validity.valid) {
      const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1)

      const response = await this.props.client.mutate({
        mutation: GET_UPLOAD_URL,
        variables: {
          fileExtension
        }
      })

      if (response.data && response.data.getPublicUploadURL) {
        const url = response.data.getPublicUploadURL.publicUploadURL
        await axios.put(url, file, {
          headers: {
            "x-ms-blob-type": "BlockBlob",
            "Content-Type": file.type || "application/octet-stream"
          }
        })
        this.setState({
          fileName: response.data.getPublicUploadURL.filename,
          bucketName: response.data.getPublicUploadURL.bucketName,
          publicUploadURL: response.data.getPublicUploadURL.publicUploadURL
        })
      }
    }
    this.setState({ isUploading: false })
  }

  componentDidMount() {
    let currentDateMaxDate = new Date()
    currentDateMaxDate.setDate(currentDateMaxDate.getDate() + 30)
    this.setState({ toMaxDate: currentDateMaxDate })

    this.getvehicleDetails()
  }

  handleSubmit = async () => {
    let vehiclesList = []
    this.state.selectedVehicles.forEach(element => {
      if(element.id != "SELECT000000ALL") vehiclesList.push(element.id)
    })
    const { data } = await this.props.client.query({
      query: GET_COMMAND_STATUS,
      variables: {
        uniqueIds: vehiclesList,
        command: '',
        from_ts: parseInt(this.state.fromDate),
        to_ts: parseInt(this.state.toDate)
      }
    })
    var fullData = []
    data.getCommandStatus.forEach((element, index) => {
      let rowData = []
      rowData.push(index + 1)
      rowData.push(element.command_display)
      rowData.push(element.response)
      rowData.push(element.status)
      fullData.push(rowData)
    })
    this.setState({ commandsList: fullData })
  }

  render() {
    const { classes } = this.props
    const multiselectStyle = {
      chips: {
        // To change css chips(Selected options)
        background: '#3f3f3fd6',
        display: 'none'
      },
      option: {
        padding: '12px',
        fontWeight: '300'
      }
    }
    return (
      <div className={classes.root}>
        <Grid container spacing={16} direction="row">
          <Grid container style={{ marginBottom: '2em' }}>
            <Grid item>
              <Button
                variant="outlined"
                color="secondary"
                className={classes.button}
                onClick={() => this.props.history.goBack()}
              >
                <ArrowBackIcon className={classes.iconSmall} />
              </Button>
            </Grid>
            <Grid item style={{ marginLeft: '1em' }}>
              <Typography variant="headline">Vehicle Commands</Typography>
            </Grid>
          </Grid>

          <Grid container padding={2} style={{ marginBottom: '3em' }}>
            <Grid item xs={8}>
              <Grid container direction="row">
                <Grid item xs={3}>
                  <InputLabel style={{ fontSize: '0.8em' }}>
                    Select Vehicles
                  </InputLabel>
                  <br />
                  <FormControl style={{ width: '90%', zIndex: '150' }}>
                    {this.state.vehicleNames && (
                      <Multiselect
                        options={this.state.vehicleNames} // Options to display in the dropdown
                        selectedValues={this.state.selectedVehicles} // Preselected value to persist in dropdown
                        onSelect={(selectedList, selectedItem) => {
                          if (selectedItem.id == 'SELECT000000ALL') {
                            this.setState({
                              selectedVehicles: this.state.vehicleNames
                            })
                          } else {
                            var selectedFiltedArray = this.state.vehicleNames.filter(
                              function(obj) {
                                return obj.id !== selectedItem.id
                              }
                            )
                            var selectedFiltedArrayALL = selectedFiltedArray.filter(
                              function(obj) {
                                return obj.id !== 'SELECT000000ALL'
                              }
                            )

                            this.setState({
                              selectedVehicles: selectedList,
                              vehicleNames: [
                                { id: 'SELECT000000ALL', name: 'Select All' },
                                selectedItem,
                                ...selectedFiltedArrayALL
                              ]
                            })
                          }
                        }}
                        onRemove={(selectedList, selectedItem) => {
                          if (selectedItem.id == 'SELECT000000ALL') {
                            this.setState({ selectedVehicles: [] })
                          } else {
                            var selectedFiltedArray = this.state.vehicleNames.filter(
                              function(obj) {
                                return obj.id !== selectedItem.id
                              }
                            )
                            var selectedFiltedArrayALL = selectedList.filter(
                              function(obj) {
                                return obj.id !== 'SELECT000000ALL'
                              }
                            )
                            this.setState({
                              selectedVehicles: selectedFiltedArrayALL,
                              vehicleNames: [
                                ...selectedFiltedArray,
                                selectedItem
                              ]
                            })
                          }
                        }}
                        displayValue="name" // Property name to display in the dropdown options
                        showCheckbox={true}
                        style={multiselectStyle}
                        avoidHighlightFirstOption={true}
                      />
                    )}
                  </FormControl>
                </Grid>
                <Grid item xl={3} md={3} style={{ marginRight: '3%' }}>
                  <InputLabel style={{ fontSize: '0.8em' }}>
                    From Date
                  </InputLabel>
                  <br />
                  <DateTimePicker
                    value={this.state.selectedFormDate}
                    onChange={this.handleFromDate}
                    format={'D MMM, Y hh:mm a'}
                  />
                </Grid>
                <Grid item xl={3} md={3} style={{ marginRight: '3%' }}>
                  <InputLabel style={{ fontSize: '0.8em' }}>To Date</InputLabel>
                  <br />
                  <DateTimePicker
                    value={this.state.selectedToDate}
                    onChange={this.handleToDate}
                    format={'D MMM, Y hh:mm a'}
                    maxDate={this.state.toMaxDate}
                    minDate={this.state.selectedFormDate}
                    maxDateMessage={
                      'To date should not be after maximal date (30 days from start date).'
                    }
                  />
                </Grid>
                <Grid item xs={2}>
                  <Button
                    onClick={this.handleSubmit}
                    type="submit"
                    color="primary"
                    variant="contained"
                    style={{ marginTop: '1em', marginLeft: '2%' }}
                    disabled={
                      !this.state.fromDate ||
                      !this.state.toDate ||
                      !this.state.selectedVehicles.length
                    }
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <Grid
                container
                direction="row"
                style={{
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'end',
                  marginTop: '1em'
                }}
              >
                <Grid item>
                  <Button
                    color="secondary"
                    onClick={this.handleClickOpen}
                    variant="raised"
                    style={{ marginRight: '1em' }}
                  >
                    Send Commands
                  </Button>{' '}
                </Grid>

                <Grid item>
                  <Button
                    color="secondary"
                    onClick={this.handleBulkOpen}
                    variant="raised"
                    style={{ marginRight: '1em' }}
                  >
                    Bulk Upload
                  </Button>{' '}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Modal
            open={this.state.openBulkModal}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <BulkUpload {...this.props} onClose={this.handleClose} />
          </Modal>
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title"
          >
            <SendCommands handleClose={this.handleClose} />
          </Dialog>
          {this.state.commandsList && (
            <Grid item xs={12}>
              {/* TODO: Replace this with a custom table going forward */}
              <MUIDataTable
                data={this.state.commandsList}
                columns={this.columns}
                options={this.options}
              />
            </Grid>
          )}
        </Grid>
      </div>
    )
  }
}

export default withStyles(style)(
  withApollo(withSharedSnackbar(VehicleCommands))
)



// WEBPACK FOOTER //
// ./src/components/Modules/VehicleCommands/index.jsx